import { fetch, post } from '@/utils/axios'

export default {
    // 发送消息
    creatTalkItem: (data) => {
        return post('/base/talkItems/creatTalkItem', data)
    },
    // 查询消息记录
    getTalkItemList: (params) => {
        return fetch('/base/talkItems/getTalkItemList', params)
    },
    // 查询供应商信息
    getVendorInfo: (params) => {
        return fetch('/base/talkItems/getVendorInfo', params)
    },
    // 查询消息汇总记录
    getTalkItemGroupList: (params) => {
        return fetch('/base/talkItems/getTalkItemGroupList', params)
    },
}